export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_sc-9316a81df0e6e9a9feaa2eed2febbc7f.png";